/*=============================
=          Google Map         =
=============================*/

var locationMaps = [].slice.call(document.querySelectorAll('.map-container'));

function initMap() {
	locationMaps.forEach(function(mapElement) {
		axios.get('/map-section/'+mapElement.getAttribute('data-location')).then(function(r) {
			var openWindow = true,
				location = r.data.location,
				coordinates = JSON.parse('['+ location.coordinates.value +']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				mapOptions = {
					zoom: 15,
					streetViewControl: false, // hide the yellow Street View pegman
					scaleControl: true, // allow users to zoom the Google Map
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: true,
					center: latLng,
					fullscreenControl: false,
					styles: mapStyles
				},
				map = new google.maps.Map(mapElement, mapOptions),
				marker = new google.maps.Marker({
					map: map,
						position: latLng,
						draggable: false,
						animation: google.maps.Animation.DROP,
						icon: '/assets/images/icons/map-pin.svg'
				}),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				});

			infowindow.open(map, marker);

	        infowindow.addListener('closeclick', function() {
	        	openWindow = false;
	        });

	        marker.addListener('click', function() {
	        	if(openWindow)
	        		infowindow.close();
	        	else
	      			infowindow.open(map, marker);

	      		openWindow = !openWindow;
	        });
		});
	});
}

if(locationMaps.length)
	window.initMap = initMap;

/*=============================
=            Sidebar          =
=============================*/

var sidebarItems = [].slice.call(document.querySelectorAll('.sidebar-links button'));

sidebarItems.forEach(function(sidebarItem) {
	sidebarItem.addEventListener('click', function() {
		var button = this,
			child = this.nextSibling,
			animation = window.getComputedStyle(child).display == 'block' ? 'slideUp' : 'slideDown';

		[].slice.call(this.parentNode.parentNode.querySelectorAll('.active:not(.closed) + ul, .open + ul')).forEach(function(open) {
			if(open != child && !open.contains(button)) {
				button = open.previousSibling;

				Velocity(open, 'slideUp', {duration: 150});

				if(button.classList.contains('active'))
					button.classList.add('closed');
				else
					button.classList.remove('open');

				open.setAttribute('aria-expanded', 'false');
			}
		});

		Velocity(child, animation, {duration: 150});

		this.classList.toggle(this.classList.contains('active') ? 'closed' : 'open');

		child.setAttribute('aria-expanded', (child.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));
	});
});